export const siteConfig = {
  brand: 'VT.co',
  assessmentUrl: '/assessment',
  contactPhone: '+17182074446',
  contactPhoneDisplay: '+1 (718) 207-4446',
  contactEmail: 'hello@vt.co',
  canonicalUrl: 'https://vt.co/',
} as const;
